import requests from 'api/index';

const prefixURL = '/employee/category';
export default {
  getCategoryListFromDB: () => requests.post(`${prefixURL}/rest/v1/listFromDB`, {}),
  removeCategory: payload => requests.post(`${prefixURL}/rest/v1/delete`, payload),
  changeOrderCategory: payload => requests.post(`${prefixURL}/rest/v1/listorder/update`, payload),
};
